import { Check } from "lucide-react";
import type { ProductionReason } from "./models";

export function DowntimeQuickReasons({ reasons, ids, selectedId, disabled, onSelect }: {
  reasons: ProductionReason[];
  ids: string[];
  selectedId: string;
  disabled: boolean;
  onSelect: (id: string) => void;
}) {
  const choices = ids.map((id) => reasons.find((reason) => reason.id === id && reason.category === "DOWNTIME"))
    .filter((reason): reason is ProductionReason => reason != null);
  if (!choices.length) return null;
  return <section className="downtime-quick-reasons" aria-label="Sık kullanılan duruş nedenleri">
    <p>Sık kullanılanlar</p>
    <div className="touch-recent-reasons">
      {choices.map((reason) => <button key={reason.id} type="button" disabled={disabled}
        aria-pressed={selectedId === reason.id} onClick={() => onSelect(reason.id)}>
        {selectedId === reason.id ? <Check size={16} aria-hidden="true" /> : null}{reason.name}
      </button>)}
    </div>
  </section>;
}
